<template >
  <v-container>
    <v-flex style="margin-top:10%;">
    
     <v-layout row v-if="error">
    <v-flex xs12 sm6 offset-sm3>
      <alert @dismissed="onDismissed" :text="error"></alert>
    </v-flex>
  </v-layout>
    <v-layout row >
          <v-flex style="margin:auto;">
             
          </v-flex>
      </v-layout>
      <v-layout >
          <v-flex  xs12 sm6 offset-sm3>
              <v-card style="background-color:white"  class="elevation-12">  <div>
                  <v-flex class="text-xs-center">
                    <v-card-title dark  class="elevation-6 blue-grey lighten ">
                     <h2>Log in form</h2>
                  </v-card-title></v-flex>
                  <v-card-text>
                      <form @submit.prevent="onSignIn">
                      <v-container>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <v-text-field
                                   prepend-icon="person"
                              name="E-mail"
                              label="e-mail"
                              id="email"
                              type="email"
                              v-model="email"
                              required></v-text-field>
                              </v-flex>
                              <v-flex xs12>
                                  <v-text-field
                                  prepend-icon="lock"
                              name="Password"
                              label="Password"
                              id="password"
                              type="password"
                              minlength="7"
                              maxlength="16"
                              v-model="password"
                              required></v-text-field>
                              </v-flex>

                              <v-flex xs12  class="text-xs-center">
                                  <div >
                                    <v-btn class="blue-grey lighten-1" type="submit" > Sign In 
                                       <span slot="loader" class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                       </span>
                                     </v-btn>
                                  </div>

                              </v-flex>
                          </v-layout>
                      </v-container>
                      </form>
                      
                  </v-card-text>
             </div> 
             </v-card>
           
          </v-flex>
      </v-layout>
      </v-flex>

  </v-container>
    </template>

    <script>
        
       export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
     user () {
       return this.$store.getters.user;
     },
     error() {
       return this.$store.getters.error;
     }
  },
  watch: {
     user (value) {
       if (value !== null && value !== undefined) {
         this.$router.push('/');
       }
     }
  },
  methods: {
     onSignIn () {
         this.$store.dispatch('signUser', { email: this.email, password: this.password });
     },
         onDismissed() {
        this.$store.dispatch("clearError");
     }
   }
 }
</script>

    
  



// WEBPACK FOOTER //
// src/components/LogIn.vue